export const ACCESS_CONTROL_ENTITIES = [
  "Permission", "Role", "User"
];
